export default "__VITE_ASSET__D2$A0Et1__"